import { motion } from 'framer-motion';
import { Gamepad, Users, Rocket, Cpu, Sparkles, ChevronDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const cards = [
  {
    icon: <Gamepad className="w-10 h-10 text-primary mb-4" />,
    title: 'مأموریت ما در بازی‌سازی',
    desc: 'ما در استودیو بازی‌سازی اکتیو لجند با هدف ارتقای سطح کیفی بازی‌سازی مستقل در ایران و خلق عناوینی نوآورانه و در سطح استانداردهای جهانی فعالیت می‌کنیم.',
  },
  {
    icon: <Users className="w-10 h-10 text-emerald-400 mb-4" />,
    title: 'تیم توسعه و خلاقیت',
    desc: 'تیم ما متشکل از بازی‌سازان، برنامه‌نویسان موتور آنریل انجین، مدلسازان سه‌بعدی و نویسندگان عاشقان بازی است که بهترین تجربه رقابتی را خلق می‌کنند.',
  },
  {
    icon: <Rocket className="w-10 h-10 text-pink-500 mb-4" />,
    title: 'چشم‌انداز و افق پیش‌رو',
    desc: 'هدف ما تبدیل شدن به برترین استودیو بازی سازی ایرانی و معرفی عناوین خلاقانه ملی در رویدادها، مسابقات بازی‌سازی و بازارهای بین‌المللی گیمینگ نظیر استیم است.',
  },
];

const technologies = [
  { name: 'Unreal Engine 5', desc: 'موتور قدرتمند توسعه بازی‌های نسل جدید', tag: 'موتور اصلی' },
  { name: 'C++ Architecture', desc: 'کدنویسی بهینه و فریم‌ورک‌های مقیاس‌پذیر گیم‌پلی', tag: 'برنامه‌نویسی' },
  { name: 'Nanite & Lumen', desc: 'نورپردازی پویا و هندسه سه‌بعدی واقع‌گرایانه', tag: 'گرافیک' },
  { name: 'Blender 3D', desc: 'طراحی محیط، شخصیت‌ها و بافت‌های سه‌بعدی', tag: 'مدل‌سازی' },
  { name: 'AI Multi-Agent', desc: 'تحریریه هوشمند و پایش لحظه‌ای فناوری‌های گیمینگ', tag: 'هوش مصنوعی' },
];

const faqs = [
  {
    q: 'استودیو بازی سازی اکتیو لجند (Active Legend) چیست و در چه حوزه‌ای فعالیت دارد؟',
    a: 'اکتیو لجند یک استودیو مستقل بازی‌سازی ایرانی است که به تولید بازی‌های رایانه‌ای رقابتی (مانند Stop Duck)، پیاده‌سازی فناوری‌های روز با موتور Unreal Engine 5 و انتشار مقالات فنی و تحلیلی صنعت بازی می‌پردازد.',
  },
  {
    q: 'بازی شاخص ساخته شده توسط استودیو اکتیو لجند چیست؟',
    a: 'بازی Stop Duck (استپ اردک) اثر شاخص این استودیو است. یک بازی اکشن رقابتی ۱ در برابر ۱ که با الهام از بازی‌های خاطره‌انگیز ایرانی «استپ هوایی» و «گرگم به هوا» ساخته شده و رتبه چهارم رویداد گیم‌جم منفی ۵ را به خود اختصاص داده است.',
  },
  {
    q: 'بنیان‌گذار و تیم سرپرستی استودیو اکتیو لجند چه کسانی هستند؟',
    a: 'استودیو بازی‌سازی اکتیو لجند توسط محمد مهدی مولایاری پایه‌گذاری شده و هدایت فنی پروژه‌ها را به همراه تیمی از متخصصان بازی‌سازی برعهده دارد.',
  },
  {
    q: 'آیا امکان همکاری با استودیو بازی سازی اکتیو لجند وجود دارد؟',
    a: 'بله، اکتیو لجند همواره از همکاری با بازی‌سازان مستعد، طراحان گرافیک و برنامه‌نویسان ایرانی استقبال می‌کند. از طریق صفحه تماس با ما می‌توانید با استودیو ارتباط برقرار نمایید.',
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: 0.15 + i * 0.1, duration: 0.6, type: 'spring', stiffness: 90 },
  }),
};

export default function About() {
  const [team, setTeam] = useState<any[]>([]);
  const [openFaq, setOpenFaq] = useState<number | null>(0);

  useEffect(() => {
    supabase
      .from('team_members')
      .select('*')
      .order('created_at', { ascending: true })
      .then(({ data }) => setTeam(data || []));
  }, []);

  return (
    <div
      className="min-h-screen bg-black text-white flex flex-col items-center justify-center px-4 py-16 pt-32 md:pt-40 pb-32"
      dir="rtl"
    >
      <Helmet>
        <title>درباره استودیو بازی سازی ایرانی اکتیو لجند | Active Legend</title>
        <meta
          name="description"
          content="درباره استودیو بازی سازی اکتیو لجند (Active Legend)؛ برترین استودیو مستقل بازی سازی ایرانی با تمرکز بر آنریل انجین ۵، توسعه بازی رقابتی Stop Duck و معرفی تیم."
        />
        <meta
          name="keywords"
          content="استودیو بازی سازی, استودیو بازی سازی ایرانی, استودیو گیم سازی, استودیوهای بازی سازی ایران, ساخت بازی با آنریل انجین 5, اکتیو لجند, Active Legend, محمد مهدی مولایاری, Stop Duck"
        />
        <link rel="canonical" href="https://activelegend.ir/about" />
        <meta property="og:title" content="درباره استودیو بازی سازی ایرانی اکتیو لجند | Active Legend" />
        <meta
          property="og:description"
          content="معرفی استودیو مستقل بازی‌سازی ایرانی اکتیو لجند، خالق بازی Stop Duck با موتور Unreal Engine 5."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://activelegend.ir/about" />
        <meta property="og:image" content="https://activelegend.ir/AE-logo.png" />
      </Helmet>

      {/* Structured Schema.org for GEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: 'درباره استودیو بازی سازی اکتیو لجند',
            description: 'معرفی استودیو مستقل بازی سازی ایرانی اکتیو لجند و تیم سازندگان',
            mainEntity: {
              '@type': 'Organization',
              name: 'Active Legend',
              alternateName: 'استودیو بازی سازی ایرانی اکتیو لجند',
              url: 'https://activelegend.ir',
              founder: {
                '@type': 'Person',
                name: 'محمد مهدی مولایاری',
              },
              knowsAbout: ['استودیو بازی سازی ایرانی', 'Unreal Engine 5', 'Stop Duck'],
            },
          }),
        }}
      />

      <div className="w-full max-w-6xl mx-auto">
        {/* Header Hero */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 border border-primary/30 text-primary text-xs font-bold mb-4"
          >
            <Sparkles className="w-4 h-4" />
            <span>پیشگام در بازی‌سازی مستقل ایران</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-6 tracking-tight"
          >
            استودیو بازی سازی اکتیو لجند
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed"
          >
            اکتیو لجند (Active Legend) یک استودیو مستقل بازی‌سازی ایرانی است که با بهره‌گیری از پیشرفته‌ترین ابزارهای توسعه بازی نظیر <span className="text-primary font-bold">Unreal Engine 5</span> و زبان C++، بازی‌های رقابتی، هیجان‌انگیز و خلاقانه تولید می‌کند و مرجع بررسی‌های تخصصی صنعت بازی است.
          </motion.p>
        </div>

        {/* 3 Value Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-20">
          {cards.map((card, i) => (
            <motion.div
              key={card.title}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              variants={cardVariants}
              className="bg-zinc-900/80 backdrop-blur-md rounded-3xl p-8 flex flex-col items-center text-center border border-white/10 hover:border-primary/40 shadow-xl transition-all duration-300"
            >
              {card.icon}
              <h2 className="text-xl font-black text-white mb-3">{card.title}</h2>
              <p className="text-gray-300 text-sm leading-relaxed">{card.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Technologies & Tech Stack Section */}
        <div className="bg-zinc-900/60 border border-white/10 rounded-3xl p-8 sm:p-12 mb-20 shadow-2xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 bg-primary/20 text-primary rounded-2xl">
              <Cpu className="w-8 h-8" />
            </div>
            <div>
              <h2 className="text-2xl font-black text-white">پشته فنی و تکنولوژی‌های استودیو</h2>
              <p className="text-xs text-gray-400 mt-1">
                استانداردها و ابزارهایی که پروژه‌های اکتیو لجند بر پایه آن‌ها خلق می‌شوند
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {technologies.map((t) => (
              <div
                key={t.name}
                className="bg-black/50 border border-white/10 rounded-2xl p-5 hover:border-white/25 transition-all"
              >
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-white text-base font-mono" dir="ltr">{t.name}</span>
                  <span className="text-[10px] bg-primary/10 text-primary font-bold px-2 py-0.5 rounded-full">
                    {t.tag}
                  </span>
                </div>
                <p className="text-xs text-gray-400 leading-relaxed">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Team Section */}
        <div className="mb-20">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">تیم سازندگان اکتیو لجند</h2>
            <p className="text-xs sm:text-sm text-gray-400">
              توسعه‌دهندگان، هنرمندان و تولیدکنندگان محتوا در استودیو
            </p>
          </div>

          {team.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {team.map((member, i) => (
                <motion.div
                  key={member.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.08 * i }}
                  className="bg-zinc-900/80 rounded-3xl p-6 flex flex-col items-center text-center border border-white/10 hover:border-primary/40 transition-all shadow-lg"
                >
                  <img
                    src={member.img_url}
                    alt={member.name}
                    className="w-24 h-24 rounded-full object-cover mb-4 border-2 border-primary/40 shadow-md"
                  />
                  <h3 className="text-lg font-bold text-white mb-1">{member.name}</h3>
                  <span className="text-xs text-gray-400 mb-4">{member.role}</span>
                  <div className="flex gap-2 justify-center">
                    {(member.socials || []).map((s: any, idx: number) => (
                      <a
                        key={idx}
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 hover:text-primary transition-colors text-xs px-2 py-1 bg-white/5 rounded-lg border border-white/5"
                      >
                        {s.icon || 'لینک'}
                      </a>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-400 py-8 bg-zinc-900/30 rounded-2xl border border-white/5 text-sm">
              استودیو اکتیو لجند با رهبری محمد مهدی مولایاری و تیمی از توسعه‌دهندگان مستقل گیمینگ.
            </div>
          )}
        </div>

        {/* Interactive FAQ Section (GEO Powerhouse) */}
        <div className="bg-zinc-900/70 border border-white/10 rounded-3xl p-6 sm:p-10 mb-16 shadow-2xl">
          <div className="text-center mb-8">
            <span className="text-xs font-bold text-primary mb-2 block">پرسش‌های متداول (FAQ)</span>
            <h2 className="text-2xl sm:text-3xl font-black text-white">
              همه چیز درباره استودیو بازی سازی ایرانی اکتیو لجند
            </h2>
          </div>

          <div className="space-y-3 max-w-4xl mx-auto">
            {faqs.map((faq, idx) => {
              const isOpen = openFaq === idx;
              return (
                <div
                  key={idx}
                  className="bg-black/50 border border-white/10 rounded-2xl overflow-hidden transition-all"
                >
                  <button
                    type="button"
                    onClick={() => setOpenFaq(isOpen ? null : idx)}
                    className="w-full flex items-center justify-between p-4 sm:p-5 text-right font-bold text-sm sm:text-base text-white hover:text-primary transition-colors gap-4"
                  >
                    <span>{faq.q}</span>
                    <ChevronDown
                      className={`w-5 h-5 shrink-0 text-primary transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    />
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-xs sm:text-sm text-gray-300 leading-relaxed border-t border-white/5 pt-3">
                      {faq.a}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center bg-gradient-to-r from-primary/10 via-amber-500/10 to-orange-500/10 border border-primary/30 rounded-3xl p-8 sm:p-12 shadow-2xl">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-3">
            علاقه‌مند به تجربه بازی‌ها یا همکاری با ما هستید؟
          </h2>
          <p className="text-gray-300 text-sm max-w-xl mx-auto mb-6 leading-relaxed">
            بازی رقابتی Stop Duck را مشاهده کرده و برای هرگونه پیشنهاد، همکاری یا ارتباط با تیم توسعه با ما در تماس باشید.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/games"
              className="w-full sm:w-auto px-8 py-3.5 rounded-2xl bg-primary hover:bg-primary/90 text-black font-extrabold text-sm shadow-lg shadow-primary/20 transition-all hover:scale-105 active:scale-95"
            >
              مشاهده بازی‌های استودیو
            </Link>
            <Link
              to="/contact"
              className="w-full sm:w-auto px-8 py-3.5 rounded-2xl bg-white/10 hover:bg-white/20 text-white font-bold text-sm border border-white/15 transition-all"
            >
              راه‌های ارتباطی و تماس
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
